module.exports = __webpack_public_path__ + "static/img/show4.834239b0.png";